import { render, staticRenderFns } from "./asidebar.vue?vue&type=template&id=5ce673fc&scoped=true&"
import script from "./asidebar.vue?vue&type=script&lang=js&"
export * from "./asidebar.vue?vue&type=script&lang=js&"
import style0 from "./asidebar.vue?vue&type=style&index=0&id=5ce673fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce673fc",
  null
  
)

export default component.exports